import type { Components, Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------
// @ts-expect-error
const MuiTreeItem: Components<Theme>['MuiTreeItem'] = {
  // ▼▼▼▼▼▼▼▼ 🎨 STYLE ▼▼▼▼▼▼▼▼
  styleOverrides: {
    // @ts-expect-error
    label: ({ theme }) => ({
      ...theme.typography.body2
    }),
    iconContainer: {
      width: 18
    }
  }
};

/* **********************************************************************
 * 🚀 Export
 * **********************************************************************/
export const treeView: Components<Theme> = {
  // @ts-expect-error
  MuiTreeItem
};
